<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="reconciliationbillformstatic"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			currentdetail: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '明细统计',
				modal_width: 600,
				modal_height: 500,
				list_footerField: [{
					field: 'stockamount',
					toFixed: 4
				}]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			staticbystockcode(){
				//console.log(this.currentdetail)
				let data = []
				let groupdata = this.$Lodash.groupBy(this.currentdetail, 'stockcode')
				for (let i in groupdata) {
					let obj = {}
					obj.id = Math.random()
					obj.stockcode = i
					obj.stockamount = this.$Lodash.sumBy(groupdata[i], (item) =>{
						if(item.stockamount){
							if(/^CD/.test(item.billcode)){						
								return parseFloat(item.stockamount)
							}
							if(/^CTD/.test(item.billcode)){
								return -parseFloat(item.stockamount)
							}
						}else{
							return 0
						}
					})

						
					data.push(obj)
				}
				return data		
			},
			staticbywarehouse(){
				let data = []
				let groupdata = this.$Lodash.groupBy(this.currentdetail, 'storageid')
				for (let i in groupdata) {
					let obj = {}
					obj.id = Math.random()
					obj.stockcode = groupdata[i][0].storagename
					obj.stockamount = this.$Lodash.sumBy(groupdata[i], (item) =>{
						if(item.stockamount){
							if(/^CD/.test(item.billcode)){						
								return parseFloat(item.stockamount)
							}
							if(/^CTD/.test(item.billcode)){
								return -parseFloat(item.stockamount)
							}
						}else{
							return 0
						}
					})
					data.push(obj)
				}
				return data
			},
			staticbyproofbill(){
				let data = []
				let groupdata = this.$Lodash.groupBy(this.currentdetail, 'proofbillcode')
				for (let i in groupdata) {
					let obj = {}
					obj.id = Math.random()
					obj.stockcode = groupdata[i][0].proofbillcode
					obj.stockamount = this.$Lodash.sumBy(groupdata[i], (item) =>{
						if(item.stockamount){
							if(/^CD/.test(item.billcode)){						
								return parseFloat(item.stockamount)
							}
							if(/^CTD/.test(item.billcode)){
								return -parseFloat(item.stockamount)
							}
						}else{
							return 0
						}
					})
					data.push(obj)
				}
				return data
			},
			staticstockcode(){
				let data = this.staticbystockcode()
				//console.log(data)
				this.$refs.reconciliationbillformstatic.reloadData(data)
			},
			staticwarehouse(){
				let data = this.staticbywarehouse()
				//console.log(data)
				this.$refs.reconciliationbillformstatic.reloadData(data)
			},
			staticproofbill(){
				let data = this.staticbyproofbill()
				//console.log(data)
				this.$refs.reconciliationbillformstatic.reloadData(data)
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						type: 'seq',
						title: '序号',
						width:50,
					},{
						field: 'stockcode',
						title: '入库/出库单',
					},
					{
						field: 'stockamount',
						title: '入库/出库小计'
					}
				]
				gridOptions.formConfig = false

				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'danger',
					code: 'export'
				},{
					name: '单据维度',
					status: 'success',
					code: 'staticstockcode'
				}, {
					name: '仓库维度',
					status: 'success',
					code: 'staticwarehouse'
				}, {
					name: '结算单维度',
					status: 'success',
					code: 'staticproofbill'
				}]

			},
			list() {
				return new Promise((resolve) => {
					let data = this.staticbystockcode()
					console.log(data)
					resolve({
						list: data
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>